<template>
  <div class="account_container">
    <div class="header_container">
        <h3>{{ $t('reviewOrder') }}</h3>
    </div>
    <div class="main-content">
      <!-- login  -->
      <div v-show="loggedIn===true" class="page-width customers_acc">
        <div class="grid">
          <div class="grid__item medium-up--two-thirds">
            <p v-show="this.$store.state.orders.orderTimeFrame.length===0">{{ $t('noPlacedOrder') }}</p>
     <!--<a href="#" v-for="tab in tabs" @click.prevent="setActiveTabName(tab.name)" style="width:50px">
        {{ tab.displayName }}
      </a>   v-model="option"-->
        <div class="filter-options-container">
          <ul class="filter-container">
            <li @click="filterOrders('All')" :class="PaymentFilter === 'All' ? 'bold' : ''" >All</li>
            <li @click="filterOrders('Pending')" :class="PaymentFilter === 'Pending' ? 'bold' : ''" >Pending Payment</li>
            <li @click="filterOrders('Packing')" :class="PaymentFilter === 'Packing' ? 'bold' : ''">Processing</li>
            <li @click="filterOrders('Released')" :class="PaymentFilter === 'Released' ? 'bold' : ''">Shipped</li>
          </ul>
          <el-select class="filter-item" v-model="option" v-bind:placeholder="$t('last3Month')" value="" @change="updateFilter">
            <el-option
              v-for="item in options"
              :key="item.value"
              :label="$t(item.label)"
              :value="item.value">
            </el-option>
          </el-select>
          </div>
            <table v-show="this.$store.state.orders.orderTimeFrame.length>0" class="responsive-table">
              <thead>
                <tr>
                  <th>{{ $t('orderNo') }}</th>
                  <th>{{ $t('order') }}</th>
                  <th>{{ $t('paymentStatus') }}</th>
                  <th>{{ $t('fulfillmentStatus') }}</th>
                  <th>{{ $t('total') }}</th>
                </tr>
              </thead>
              <tbody>
              <tr v-for="(order, index) in filteredOrders" data-index="index" :key="index">
                <!-- <td data-label="Order"> -->
                <td v-bind:data-label="$t('order')">
                  <p class="btn" @click="navTo(order.SalesOrder_id)">
                    #{{order.SONum}}
                  </p>
                </td>
                <td v-bind:data-label="$t('date')">{{order.OrderDate}}</td>
                <td v-bind:data-label="$t('paymentStatus')">{{order.PaymentStatus}}</td>
                <td v-bind:data-label="$t('fulfillmentStatus')">{{order.SaleStatus}}</td>
                <td v-bind:data-label="$t('total')">${{order.FinalPrice}}</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
        </div>
        <!--<div v-else>
          Loading...
        </div>-->
      </div>
    </div> 
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex';

export default {
  name: "account-order",
  data(){
    return{
      orderTimeFrame:[],
      loaded: false,
      PaymentFilter: 'All',
      // option: 'last 3 month',
      option: '',
      options: [{
        value: '1',
        label: 'last3Month'
      }, {
        value: '2',
        label: 'last6Month'
      }, {
        value: '3',
        label: 'last12Month'
      },{
        value: '4',
        label: 'all'
      },],
       tabs: [
        {
          name: 'All',
          displayName: '全部',
        },
        {
          name: 'Pending',
          displayName: '等待付款',
        },
        {
          name: 'Processing',
          displayName: '处理中',
        },
        {
          name: 'Shipped',
          displayName: '已运送',
        },
      ],
      activeTabName: null,
      list:[],

    }
  },
  methods:{
    ...mapMutations('auth', ['logout', 'updateLoginStatus']),
    ...mapActions('orders', ['fetchOrderByTimeFrame','fetchOrderDetails','cancelOrder','fetchConsolidatedOrders']),
    navTo(id) {
        this.$router.push({name: 'order', params: {order_id: id}});
    },
    updateFilter(value) {
      if(value === '1') {
        this.$store.dispatch('orders/fetchOrderByTimeFrame', 3);
      }
      if(value === '2') {
        this.$store.dispatch('orders/fetchOrderByTimeFrame', 6);
      }
      if(value === '3') {
        this.$store.dispatch('orders/fetchOrderByTimeFrame', 12);
      }
      if(value=== '4'){
        this.$store.dispatch('orders/fetchOrderByTimeFrame', 99);
      }     
    },
    filterOrders(filter) {
      this.PaymentFilter = filter;
    },
  },
  mounted() {
    //const month = 3;
    //this.$store.dispatch('orders/fetchOrderByTimeFrame',month);
  },
  computed: mapState({
    loggedIn: state => state.auth.loggedIn,
    filteredOrders() {
      if (this.PaymentFilter === 'All') {
        return this.$store.state.orders.orderTimeFrame;
      } else if (this.PaymentFilter === 'Packing' || this.PaymentFilter === 'Released') {
        let list = [];
        this.$store.state.orders.orderTimeFrame.map( order => {
          if (order.SaleStatus === this.PaymentFilter) {
            list.push(order);
          }
        })
        return list;
      } else {
        let list = [];
        this.$store.state.orders.orderTimeFrame.map( order => {
          if (order.PaymentStatus === this.PaymentFilter) {
            list.push(order);
          }
        })
        return list;
        }
      },
  }),
  watch: {
    '$store.state.orders.orderTimeFrame': {
      immidiate: true,
      handler(newval) {
        this.loaded = true;
      }
    }
  }
}
</script>
<style scoped lang="less">
// @import "../../assets/css/profile.less";
// @import "../../assets/css/public.less";
@import "../../assets/css/profileorder.less";
</style>



// WEBPACK FOOTER //
// src/view/Profile/order.vue